
import iCon from '@/components/ui/svgicon/index.vue'
import Dropdown from '@/components/ui/dropdown/index.vue';
import Button from '@/components/ui/button/index.vue';
import { computed, reactive } from 'vue';
import { ENV, FEATURENAME, LANG, POPUP, TASKTAB } from '@/enum/enum';
// import store from '@/store';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { uuid } from 'vue-uuid';
import { useI18n } from 'vue-i18n';
import { checkEnvFromDomain } from '@/utils/utils';

export default {
  components: {
    iCon,
    Dropdown,
    Button,
  },
  props: {
    userName: {
      type: String,
      default: '- - - ',
    },
    email: {
      type: String,
      default: 'aa@asus.com.tw',
    },
    sideInfo: {
      type: Array,
      default() {
        return [
          {link: FEATURENAME.TASK,
            text: 'Contact us',
            query: { tabId: TASKTAB.EXECUTED },  //有default預設的參數必須帶入
            icon: 'top-email_n',
            gtmId: '__taskManagement',
            sub: []
          }
        ]
      }
    }, //end: sidemenu

  },
  setup(props, { emit }) {
    const { locale, t } = useI18n();


    const router = useRouter();
    const store = useStore();
    const brand = computed(() => store.state.brand);
    // const storeState = store.state;
    const state = reactive({
      langSelectedIndex: 0,
      isShowProfile: false,
      infoSelectedIndex: 0,
    })

    // check env
    console.log('process', process.env.NODE_ENV)
    let _env = checkEnvFromDomain();


    let _checkCurrentLang = ()  => {
      console.log('_checkCurrentLang');
      let _lang = localStorage.getItem('language');
      console.log(props.sideInfo)
      state.langSelectedIndex = props.sideInfo[0].sub.findIndex(obj => {
        return obj.val == _lang;
      })
      store.commit('setLangIsSelected', _lang)

    }//end: _checkCurrentLang

    _checkCurrentLang();



``

    //multi lang
    const infoList = computed(() => {
      let arr = [t('__main.__userManual', {brand: brand}), t('__main.__proartCalibrationWindows',{brand: brand}), t('__main.__userLicenseAgreement'), t('__main.__privacyPolicy'),]
      // t('__main.__license')
      if (_env !== ENV.PROD && _env !== ENV.STAGING  && _env !== ENV.DEV) {
        return arr
      }else{
        // arr.shift()
        // arr.splice(2,1)
        return arr
      }
      
    });





    const onClickContact = () => {
      console.log('onClickContact');
      emit('onClickContact')
    }
    const onClickLang = (e) => {
      emit('onClickLang', e.value )
    }
    const onClickProfile = () => {
      state.isShowProfile = !state.isShowProfile;
    }
    const styleProfileShow = computed(() => [
      { 'active': state.isShowProfile }
    ])
    const showPopup = (popupName, data = '') => {
      const modalConfig = {
        type: popupName,
        data: data,
        isShow: true,
      }
      store.commit('setIsShowModal', modalConfig)
    }

    //轉換各國語系連結
    let _urlMutiLangLink = () => {
      let _urlLang = '';
      let _url = {
        manual: `https://www.asus.com/${_urlLang}support/FAQ/1049325`,
        windows: `https://www.asus.com/${_urlLang}support/FAQ/1043733`,
      };
      let _selectedLang = locale.value;
      

      switch(_selectedLang){
        case LANG.EN:
          _urlLang = '';
          break;
        case LANG.TW:
          _urlLang = 'TW/';
          break;
        case LANG.ITA:
          _urlLang = 'it/';
          break;
        case LANG.FRE:
          _urlLang = 'fr/';
        break;
        case LANG.GER:
          _urlLang = 'de/';
          break;
        case LANG.SPAN:
          _urlLang = 'es/';
          break;
        case LANG.RUSSIAN:
          _urlLang = 'ru/';
          break;
        case LANG.TUR:
          _urlLang = 'tr/';
          break;
        case LANG.POLISH:
          _urlLang = 'pl/';
          break;
        case LANG.DUTCH:
          _urlLang = 'nl/';
          break;
        case LANG.UKR:
          _urlLang = 'ua-ua/';
          break;
        case LANG.JP: 
          _urlLang = 'jp/';
          break;
        case LANG.KOR: 
          _urlLang = 'kr/';
          break;
        case LANG.THAI:
          _urlLang = 'th/';
          break;
        case LANG.VIE:
          _urlLang = 'vn/';
          break;
        case LANG.IND:
          _urlLang = 'id/';
          break;
        default: 
          _urlLang = '';
          break;
      }

      _url = {
        manual: `https://www.asus.com/${_urlLang}support/FAQ/1049325`,
        windows: `https://www.asus.com/${_urlLang}support/FAQ/1043733`,
      };

      return _url;
    }

    console.log(' ---- > _urlMutiLangLink().manual;', _urlMutiLangLink());


    const onClickInfo = (index) => {
      emit('onClickInfoList', index)
    }

    const logout = () => {
      emit('onLogout');
    }

    const onClickLogo = () => {
      router.push({ name: FEATURENAME.DASHBOARDDEFAULT });
    }

    const handleProfileFocusOut = () => {
      state.isShowProfile = false;
    }


    const onClickNotification = () => {
      console.log('onClickNotification');
      emit('onClickNotification')
    }

    const onClickSideBar = () => {
      // console.log('onClickSideBar');
      store.commit('setOpenSideBar', true)
    }


    store.watch(state => (state.langIsSelected), (val) => {
      let localIndex = props.sideInfo[0].sub.findIndex(obj => {
        return obj.val == val;
      })
      if(state.langSelectedIndex != localIndex) state.langSelectedIndex = localIndex
    })


    return {
      onClickContact,
      onClickLang,
      state,
      onClickProfile,
      styleProfileShow,
      onClickInfo,
      handleProfileFocusOut,
      logout,
      onClickLogo,
      t,
      locale,
      infoList,
      onClickNotification,
      onClickSideBar,
      brand
    }
  }
}


